<template xmlns="http://www.w3.org/1999/html">
  <div class="inner-base" :style="styles">
    <div class="wrap">
      <template v-if="+lpId === 1">
        <div class="btn-area kurenotori">
          <div class="btn-block left">
            <span class="lead-word"></span>
            <span v-if="hasFreeBtn" class="btn free-btn" @click.stop="onFreeBtnClick">{{ bannerInfo.freeBtnFace }}</span>
          </div>
          <div class="btn-block right">
            <span class="lead-word"></span>
            <span v-if="hasSubScrBtn" class="btn subscr-btn" @click.stop="onSubscrBtnClick"><span class="upper">占い放題</span><span class="lower">月額528円(税込)</span></span>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="bnr-title" v-html="bannerInfo.title"></div>
        <div class="btn-area">
          <span v-if="hasFreeBtn" class="btn free-btn" @click.stop="onFreeBtnClick">{{ bannerInfo.freeBtnFace }}</span>
          <span v-if="hasSubScrBtn" class="btn subscr-btn" @click.stop="onSubscrBtnClick"><span class="upper">占い放題</span><span class="lower">月額528円(税込)</span></span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingBannerInner',
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    subscUrl: {
      type: String,
      default: ''
    },
    bannerInfo: {
      type: Object,
      default(){
        return {
          title: '<span class="name">暮れの酉</span>の<span class="emphasis">鳳凰数術</span>で',
          freeBtnFace: '無料で占う',
          colors: {
            background: '#fffbe3',
            baseText: 'black',
            emphasis: 'red',
            decos: 'blue',
            freeBtn: 'brown',
            freeBtnBg: 'white',
          }
        }
      }
    }
  },
  computed: {
    styles(){
      const info = this.bannerInfo.colors
      return {
        '--background': info.background,
        '--base-text': info.baseText,
        '--emphasis': info.emphasis,
        '--decos': info.decos,
        '--free-btn': info.freeBtn,
        '--free-btn-bg': info.freeBtnBg,
      }
    },
    hasFreeBtn(){
      return true
    },
    hasSubScrBtn(){
      return true
    }
  },
  methods: {
    onFreeBtnClick(){
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-floating-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
    onSubscrBtnClick(){
      location.href = this.$handoverParams(this.subscUrl)
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-floating-subsc-button`,
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_background: var(--background);
$l_col_base_text: var(--base-text);
$l_col_emphasis: var(--emphasis);
$l_col_decos: var(--decos);
$l_col_free_btn: var(--free-btn);
$l_col_free_btn_bg: var(--free-btn-bg);

.inner-base {
  width: 100%;
  background: $l_col_background;
  color: $l_col_base_text;
  text-align: center;
  .wrap {
    width: 100%;
    max-width: 580px;
    margin: 0 auto;
    padding: 12px 16px 26px;
    @include mq('w580') {
      padding: 16px 16px 17px;
    }
  }
  .bnr-title {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 4px;
    /deep/ .name {
      font-size: 16px;
    }
    /deep/ .emphasis {
      font-size: 18px;
      color: $l_col_emphasis;
    }
    &::before,
    &::after {
      content: "";
      display: inline-block;
      border: 1px solid $l_col_decos;
      background: $l_col_decos;
      height: 1px;
      width: 16px;
      border-radius: 2px;
      box-sizing: border-box;
    }
    &::after {
      transform: translate(0,-4px) rotate(-55deg);
    }
    &::before {
      transform: translate(0,-4px) rotate(55deg);
    }
  }

  .btn-area {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .btn {
      display: inline-flex;
      height: 45px;
      width: 48.4%;
      border-radius: 35px;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
      font-size: 15px;
      font-weight: bold;
      line-height: 1;
      vertical-align: top;
      cursor: pointer;

      &.free-btn {
        background: $l_col_free_btn_bg;
        color: $l_col_free_btn;
        border: 2px solid $l_col_free_btn;
      }

      &.subscr-btn {
        background: linear-gradient(86.53deg, #ff7497 21.4%, #cb8bff 76.64%);
        color: white;

        span {
          display: block;
          width: 100%;
          line-height: 1.2;
        }

        .lower {
          font-size: 12px;
        }
      }
    }

    &.kurenotori {
      .btn-block {
        width: 50%;
        flex-grow: 1;
        .btn {
          width: 100%;
        }
        .lead-word {
          width: 100%;
          height: 0;
          padding-top: 20.36%;
          display: flex;
          position: relative;
          margin-bottom: 2px;
          &::after {
            content: "";
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            margin: 0 auto ;
          }
        }
        &.left {
          padding-right: 4px;
          .lead-word {
            &::after {
              background: url(/static/img/recommend/lp/kurenotori/banner_lead2_sp.svg) no-repeat center center;
              background-size: 100% auto;
              width: 108%;
              left: 50%;
              transform: translate(-50%, 0);
              @include mq('w580') {
                width: 100%;
                background-image: url(/static/img/recommend/lp/kurenotori/banner_lead2_pc.svg);
              }
            }
          }
        }
        &.right {
          padding-left: 4px;
          .lead-word {
            &::after {
              background: url(/static/img/recommend/lp/kurenotori/banner_lead3_sp.svg) no-repeat center center;
              background-size: 100% auto;
              @include mq('w580') {
                background-image: url(/static/img/recommend/lp/kurenotori/banner_lead3_pc.svg);
              }
            }
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/FloatingBannerInner.vue